/**
 * Contenidos abiertos (contrato 3.1, `content_opened`): un clic dentro de un
 * elemento marcado con el atributo `data-track` (su valor, un slug: IPID,
 * condiciones, nota legal, detalle de coberturas…). Solo se manda el slug.
 */
import { isSlug } from "./events";

export interface ContentWatcherTarget {
  contentOpened: (contentId: string) => void;
}

/** Slug de la marca `data-track` más cercana al clic, o null. */
export const contentIdOf = (target: EventTarget | null): string | null => {
  const el = target as Element | null;
  if (!el || typeof el.closest !== "function") return null;
  const marked = el.closest("[data-track]");
  const id = marked ? marked.getAttribute("data-track") : null;
  return isSlug(id) ? id : null;
};

export const installContentWatcher = (
  target: ContentWatcherTarget,
  doc: Document = document
): (() => void) => {
  const onClick = (event: Event) => {
    try {
      const id = contentIdOf(event.target);
      if (id) target.contentOpened(id);
    } catch {
      /* el tracking nunca rompe la app */
    }
  };
  doc.addEventListener("click", onClick, true);
  return () => doc.removeEventListener("click", onClick, true);
};
